import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';

import Header from '../../../../components/controls/header/Header.jsx';
import Image from '../../../controls/image/Image.jsx';
import {
    ICON_LOGOUT,
    ICON_ARROW_GRAY,
} from 'pluton-core/lib/constants/image.constant';
import AuthInput from '../../../controls/authInput/AuthInput.jsx';

import { routes } from 'pluton-core/lib/constants/routes.constant';
import { history } from '../../../../entry/history';
import ProgressBar from '../../../controls/progressBar/ProgressBar.jsx';
import { GLOBAL_TYPES } from 'pluton-core/lib/device/types/global.types';
import { COST_MODE } from 'pluton-core/lib/services/core/cost/cost.constant';


class SettingsPage extends Component {

    handleSubmit = () => {
        const {
            modelForm,
            modelData,
            handleOnValidate,
            handleSubmit
        } = this.props;

        const validation = modelForm.validate(modelData);
        handleOnValidate(validation);
        if (!validation.isValid) {
            return;
        }

        handleSubmit(modelData);
        history.goBack();
    };

    handleOnChangeCostMode = (event) => {
        const value = event.target.checked ?
            COST_MODE.WATT : COST_MODE.MONEY;
        this.props.handleOnChangeCostMode(value);
    };

    handleOnChangeServerIP = (event) => {
        this.props.handleOnChangeServerIP(event.target.value.trim());
    };

    handleOnChangeServerPort = (event) => {
        this.props.handleOnChangeServerPort(event.target.value.trim());
    };

    handleOnLogout = () => {
        this.props.handleOnLogout(history);
    };

    handleOnKeyPressServerIP = (event) => {
        if (event.charCode === 13) {
            this.refs.serverPort.refs.input.focus();
        }
    };

    handleOnKeyPressServerPort = (event) => {
        if (event.charCode === 13) {
            this.handleSubmit();
        }
    };

    handleOnBack = () => {
        history.goBack();
    };

    renderHeader = () => {
        const { loginModelData } = this.props;
        const imageLogoutView = (
            loginModelData.isAuth &&
            <Image onClick={this.handleOnLogout}
                   src={ICON_LOGOUT}
                   className="header__icon header__icon--right"
                   imgClassName="icon icon--header"/>
        );

        return (
            <Header headerTitle='Setting'>
                <Link className="header__link header__link--left"
                      onClick={this.handleOnBack}>
                    <Image src={ICON_ARROW_GRAY}
                           className="header__icon header__icon--left"
                           imgClassName="icon icon--header"/>
                </Link>
            </Header>
        );
    };

    renderServerIPAddress = (serverIPPlaceholder, isValidRemote) => {
        const {
            error,
            modelData
        } = this.props;

        const value = (error && modelData.serverIPError ?
                '' : modelData.settings ?
                modelData.settings[GLOBAL_TYPES.SERVER_IP] : '') || '';

        return (
            <div>
                <div className="label">
                    IoT server IP
                </div>
                <AuthInput
                    ref="serverIP"
                    placeholder={serverIPPlaceholder}
                    className={'field'}
                    value={value}
                    onChange={this.handleOnChangeServerIP}
                    onKeyPress={this.handleOnKeyPressServerIP}
                />
                {
                    (!modelData.isValid || !isValidRemote) &&
                    <div className="field-error">
                        {modelData.serverIPError}
                    </div>
                }
            </div>
        );
    };

    renderServerPortAddress = (serverPortPlaceholder, isValidRemote) => {
        const {
            error,
            modelData
        } = this.props;

        const value = (error && modelData.serverPortError ?
                '' : modelData.settings ?
                modelData.settings[GLOBAL_TYPES.SERVER_PORT] : '') || '';

        return (
            <div>
                <div className="label">
                    IoT server port
                </div>
                <AuthInput
                    ref="serverPort"
                    placeholder={serverPortPlaceholder}
                    className={'field'}
                    value={value}
                    onChange={this.handleOnChangeServerPort}
                    onKeyPress={this.handleOnKeyPressServerPort}
                />
                {
                    (!modelData.isValid || !isValidRemote) &&
                    <div className="field-error">
                        {modelData.serverPortError}
                    </div>
                }
            </div>
        );
    };

    renderCostMode = (costModePlaceholder) => {
        const value = this.props.modelData.settings[GLOBAL_TYPES.COST_MODE] === COST_MODE.WATT;
        const label = costModePlaceholder + ':' + (value ? 'watt' : '$');

        return (
            <div className="form-group">
                <label className="checkbox" htmlFor="checkbox">
                    <span className="checkbox__text">
                        {label}
                    </span>
                    <input
                        type="checkbox"
                        className="checkbox__custom"
                        id="checkbox"
                        checked={value}
                        onChange={this.handleOnChangeCostMode}
                    />
                    <label htmlFor="checkbox"/>
                </label>
            </div>
        );
    };

    renderBody() {
        const {
            error,
            modelForm,
            modelData
        } = this.props;

        const {
            isValid: isValidRemote,
            costModePlaceholder,
            serverIPPlaceholder,
            serverPortPlaceholder
        } = modelForm.getPlaceholders(modelData, error);

        return (
            <div className="form">
                {this.renderServerIPAddress(serverIPPlaceholder, isValidRemote)}
                {this.renderServerPortAddress(serverPortPlaceholder, isValidRemote)}
                {/*this.renderCostMode(costModePlaceholder)*/}
            </div>
        );
    }

    renderProgressBar = () => {
        const { modelData } = this.props;
        if (!modelData.isLoading) {
            return null;
        }

        return (
            <ProgressBar/>
        );
    };

    renderSaveButton = () => {
        return (
            <div className="btn-wrap">
                <Link onClick={this.handleSubmit} className="btn btn--prime">
                    Save
                </Link>
            </div>
        );
    };

    renderLogoutButton = () => {
        const { loginModelData } = this.props;

        return (
            loginModelData.isAuth &&
            <div className="btn-wrap">
                <Link onClick={this.handleOnLogout} className="btn btn--secondary">
                    Log Out
                </Link>
            </div>
        );
    };

    renderPinLink = () => {
        const { loginModelData } = this.props;
        if (!loginModelData.isAuth) {
            return null;
        }

        return (
            <div className="btn-wrap">
                <Link to={`${routes.pin()}`} className="btn btn--secondary">
                    Generate PIN
                </Link>
            </div>
        );
    };

    render() {
        return (
            <div className="app-container">
                <div className="page page--setting">
                    {this.renderHeader()}
                    <div className="page__content page__content--settings">
                        {this.renderBody()}
                        {this.renderProgressBar()}
                        {this.renderSaveButton()}
                        {this.renderPinLink()}
                        {this.renderLogoutButton()}
                    </div>
                    <div className="version">
                        <span className="version__caption">Version:</span>
                        <span className="version__number">{__APP_VERSION__}</span>
                    </div>
                </div>
            </div>
        );
    }
}

SettingsPage.PropTypes = {
    model: PropTypes.func,
    modelForm: PropTypes.func,
    modelData: PropTypes.object,
    error: PropTypes.object,
    loginModelData: PropTypes.object,

    handleOnLogout: PropTypes.func,
    handleOnChangeCostMode: PropTypes.func,
    handleOnChangeServerIP: PropTypes.func,
    handleOnChangeServerPort: PropTypes.func,
    handleOnValidate: PropTypes.func,
    handleSubmit: PropTypes.func,
};

export default SettingsPage;



// WEBPACK FOOTER //
// ./app/components/pages/service/settings/Settings.page.jsx